import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'

/** Appends "(inactive)" for an inactive field. */
export const useFormatBudgetCustomFieldName = () => {
  const intl = useProcurifyIntl()

  return (name: string, isActive: boolean): string =>
    isActive
      ? name
      : intl.formatMessage(messages.inactiveCustomFieldLabel, { name })
}
